import { Component, Input, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { NgForOf, NgIf } from '@angular/common';
import { AyaPriceListHolidayStartDate, SessionBreaks } from '../../models';
import { OrdinalDatePipe } from '@lx/shared/ui/pipes';
import { getOrdinal } from '@lx/shared/utils';

type SessionBreakColumn = {
  key?: string;
  duration?: number;
  order?: number;
  orderLabel?: string;
  durationLabel?: string;
};

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-session-breaks',
  templateUrl: './aya-session-breaks.component.html',
  styleUrls: ['./aya-session-breaks.component.scss', './print-aya-session-breaks.component.scss'],
  imports: [TableModule, NgForOf, OrdinalDatePipe, NgIf],
})
export class AyaSessionBreaksComponent implements OnInit {
  @Input() sessionBreaksBySchool: SessionBreaks | undefined;

  protected columns: SessionBreakColumn[] = [];

  ngOnInit(): void {
    const holidayStartDates: AyaPriceListHolidayStartDate[] = (this.sessionBreaksBySchool?.breaks ?? []).flatMap((param) => param?.holidayStartDates ?? []);

    const localLabels = holidayStartDates.map((holidayStartInfo) => this.mapSessionBreakLabels(holidayStartInfo));

    const uniqueMap = new Map<string, SessionBreakColumn>(localLabels.filter((col) => !!col.key).map((col) => [col.key, col]));

    this.columns = Array.from(uniqueMap.values()).sort((c1, c2) => (c1?.duration ?? 0) - (c2?.duration ?? 0));
  }

  private mapSessionBreakLabels(holidayStartInfo: AyaPriceListHolidayStartDate): SessionBreakColumn {
    const { duration, order } = holidayStartInfo ?? {};

    const key = duration != null && order != null ? `${duration}-${order}` : undefined;
    const durationLabel = !duration ? 'All courses' : `${duration} month courses`;
    const orderLabel = order != null ? `${this.getHolidayOrdinal(order)} Holiday Start` : undefined;

    return { key, duration, order, durationLabel, orderLabel };
  }

  private getHolidayOrdinal(order: number): string {
    if (!order || order <= 0) {
      return '';
    }

    // Only 1st and 2nd holidays are used in AYA session breaks
    const actualOrder = order === 1 ? 1 : 2;

    return getOrdinal(actualOrder, true);
  }
}
